<template>
  <div class="wrapper">
    <SideNavBar
      class="main-nav"
      :class="openMenu ? 'open-nav' : 'closed-nav'"
    />
    <div :style="{ width: computedBoxWidth }">
      <router-view
        class="page box sticky-parent"
        v-if="$route.name == 'permissionDenied'"
      />
      <router-view
        class="page box sticky-parent"
        v-else-if="$route.name == 'loadingPage'"
      />
      <div v-else class="box sticky-parent">
        <div class="sticky-child">
          <ToolBar class="content" />
          <div class="box2">
            <div class="flex-r-space-between">
              <Dropdown
                class="dropdown"
                @capabilityChanged="updateCapability"
                v-if="showDropdown"
              />
              <AlertsHeader class="dropdown" v-if="showAlertsHeader" />
              <AlertsHeaderV2 class="dropdown" v-if="showAlertsHeaderV2" />
              <!-- Removing Synthetic Monitoring Toggle  -->
              <!-- <div
              v-if="this.app.currentSideNav.name === bmPathName"
              class="flex flex-align-center tcontainer"
            >
              <RexToggleCurvey
                @valueChanged="toggleSyntheticUser"
                :defaultValue="syntheticUserEnabled"
                label="Synthetic Monitoring User"
              />
            </div> -->
            </div>
            <div class="line-separator" v-if="showLineSeparator" />
            <NavTab class="navtab" v-if="showNavTab" />
          </div>
        </div>
        <!-- <div class="box2"> -->

        <div class="view-body">
          <div class="box2" :class="openMenu && 'open-menu'">
            <router-view
              class="page"
              v-if="app.currentSideNav.name !== 'Settings'"
            />
            <router-view
              class="page box2-footer"
              v-if="app.currentSideNav.name === 'Settings'"
            />
          </div>
          <TheFooter
            class="footer footer-apm"
            v-if="app.currentSideNav.name === 'APM'"
          />
          <TheFooter class="footer" v-if="app.currentSideNav.name !== 'APM'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import NavTab from '../components/Main/TheNavTab.vue';
import SideNavBar from '../components/Main/TheSideNavBar.vue';
import ToolBar from '../components/Main/TheToolBar.vue';
import Dropdown from '../components/Main/TheDropdown.vue';
import TheFooter from '../components/Main/TheFooter.vue';
import settings from '@/utils/templates/settings.template';
import home from '@/utils/templates/home.template';
import vm from '@/utils/templates/vm.template';
import bm from '@/utils/templates/browser.template';
import alerts from '@/utils/templates/alert.template';
import alertsV2 from '@/utils/templates/alertsV2.template';
import mobile from '@/utils/templates/mobile.template';
import notification from '@/utils/templates/notification.template';
import database from '@/utils/templates/database.template';
import AlertsHeader from '@/components/Alert/headerAlerts.vue';
import AlertsHeaderV2 from '@/components/AlertsV2/headerAlerts.vue';
import RexToggleCurvey from '@/rex-components/rex-toggle-curvey.vue';
import wsm from '@/utils/templates/wsm.template';
import integrations from '../utils/templates/integrations';
import cloud from '../utils/templates/cloud';
import sm from '@/utils/templates/sm.template';
import log from '@/utils/templates/log.template';
import analytics from '@/utils/templates/analytics.template';
import digitalExperience from '../utils/templates/digitalExperience';
import dataUsage from '@/utils/templates/billing.usage.template';
import mq from '@/utils/templates/mq.template';
import k8m from '@/utils/templates/k8m.template';
import apm from '@/utils/templates/apm.template';

// @ is an alias to /src
export default {
  name: 'Index',
  components: {
    SideNavBar,
    ToolBar,
    NavTab,
    Dropdown,
    TheFooter,
    RexToggleCurvey,
    AlertsHeader,
    AlertsHeaderV2,
  },
  data: function () {
    return {
      bmPathName: bm.name,
      alertPathName: alerts.name,
    };
  },
  computed: {
    ...mapState('globalState', ['app']),
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'timezoneoffset',
    ]),
    ...mapState('globalState/app', ['openMenu', 'currentCapability']),
    closed() {
      return true;
    },
    ...mapState('browserState/browserCommonState', ['syntheticUserEnabled']),
    computedBoxWidth() {
      const sideNavWidth = this.openMenu ? 20 : 6.1875;
      return `calc(100vw - ${sideNavWidth}em)`;
    },
    showDropdown() {
      return (
        this.app.currentSideNav.name === apm.name ||
        this.app.currentSideNav.name === mobile.name ||
        this.app.currentSideNav.name === bm.name
      );
    },
    showAlertsHeader() {
      return this.app.currentSideNav.name == alerts.name;
    },
    showAlertsHeaderV2() {
      return (
        this.app.currentSideNav.name == alertsV2.name &&
        this.$route.name !== 'tagGroupingV2' &&
        this.$route.name !== 'extTagGroupingV2'
      );
    },
    showLineSeparator() {
      return (
        this.app.currentSideNav.name !== settings.name &&
        this.app.currentSideNav.name !== dataUsage.name &&
        this.app.currentSideNav.name !== vm.name &&
        this.app.currentSideNav.name !== home.name &&
        this.app.currentSideNav.name !== database.name &&
        this.app.currentSideNav.name !== wsm.name &&
        this.app.currentSideNav.name !== cloud.name &&
        this.app.currentSideNav.name !== sm.name &&
        this.app.currentSideNav.name !== notification.name &&
        this.$route.name !== 'tagGroupingV2' &&
        this.app.currentSideNav.name !== digitalExperience.name &&
        this.app.currentSideNav.name !== log.name &&
        this.app.currentSideNav.name !== mq.name &&
        this.$route.name !== 'extTagGroupingV2' &&
        this.app.currentSideNav.name !== k8m.name &&
        this.app.currentSideNav.name !== analytics.name
      );
    },
    showNavTab() {
      return (
        this.app.currentSideNav.name !== vm.name &&
        this.app.currentSideNav.name !== home.name &&
        this.app.currentSideNav.name !== database.name &&
        this.app.currentSideNav.name !== wsm.name &&
        this.app.currentSideNav.name !== digitalExperience.name &&
        this.app.currentSideNav.name !== notification.name &&
        this.app.currentSideNav.name !== log.name &&
        this.app.currentSideNav.name !== mq.name &&
        this.app.currentSideNav.name !== integrations.name &&
        this.app.currentSideNav.name !== cloud.name &&
        this.app.currentSideNav.name !== k8m.name &&
        this.app.currentSideNav.name !== analytics.name
      );
    },
  },

  methods: {
    ...mapMutations('globalState/user', {
      setIsAuthenticatedMuatation: 'setIsAuthenticated',
    }),
    ...mapMutations('globalState/app', [
      'setCurrentCapability',
      'setHideDateTimePicker',
      'setDisableDateTimePickerOptions',
    ]),
    ...mapActions('globalState/user', {
      getProfileAction: 'getProfile',
      getUserLoginCount: 'getUserLoginCount',
      getUserLastLogin: 'getUserLastLogin',
      getTimeZone: 'getTimeZone',
    }),
    ...mapActions('browserState/browserCommonState', ['setSyntheticUser']),
    updateCapability(selectedCapability) {
      this.setCurrentCapability(selectedCapability);
    },
    toggleSyntheticUser(value) {
      this.setSyntheticUser(value);
    },
    async onInit() {
      try {
        this.setHideDateTimePicker(false);
        this.setDisableDateTimePickerOptions([]);
        await this.getProfileAction().then((resp) => {});
        await this.getUserLoginCount();
        await this.getUserLastLogin();
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  beforeMount() {
    this.getTimeZone();
  },
  created() {
    this.onInit();
  },
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: width 0.3s ease;
}
.line-separator {
  border: 0.03125em solid $line-separator;
  margin-top: 0.6875em;
  opacity: 80%;
}
.box2 {
  display: flex;
  flex-direction: column;
  margin-right: 0.9375em;
  padding-left: 1.5625em;
}
.box2-footer {
  min-height: calc(95vh - (3.5438em + 2.625em));
}

.header {
  grid-area: header;
}
.content {
  grid-area: content;
}
.open-nav {
  flex: 0 0 20em;
}
.closed-nav {
  flex: 0 0 6.1875em;
}
.main-nav {
  position: relative;
  z-index: 100;
}
.page {
  grid-area: page;
  height: 100%;
}
.navtab {
  grid-area: tab;
}
.wrapper {
  display: flex;
  flex-direction: row;
}
.footer {
  position: sticky;
  width: 100%;
  display: grid;
  place-items: center;
}
.footer-apm {
  margin-top: 5.1875em;
}
.sticky-parent {
  overflow: visible;
  height: 100%;
}
.view-body {
  @include flex-column;
  min-height: calc(100dvh - 50px);
  justify-content: space-between;
}
.sticky-child {
  // position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: $bg-primary;
}
.tcontainer {
  margin-top: 0.8125em;
}
</style>
